import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { FetchOnePlanRequest, PlansService } from '@core/services/plans/plans.service';

import * as PlanActions from './plan.actions';

@Injectable()
export class PlanEffects {
  private actions$ = inject(Actions);
  private planService = inject(PlansService);
  fetchPlans$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlanActions.fetchPlans),
      switchMap(({ id }) => {
        const request: FetchOnePlanRequest = { planId: String(id) };
        return this.planService
          .fetchOne$(request)
          .pipe(map((plan) => PlanActions.setPlan({ plan: plan })));
      })
    )
  );
}
